module.exports = {"id":"233986","name":"Jony Reitosa","rating":"71","photo":"./data/images/photos/1/233986.png","club":{"name":"Atlético-GO","logo":"./data/images/clubs/Atletico-GO.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonyReitosa0.json
// module id = 2123
// module chunks = 0